import { render } from "./accounts.vue?vue&type=template&id=40b590a9"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"
script.render = render

export default script